import { Component } from '@angular/core';
var BsTimepickerViewComponent = (function () {
    function BsTimepickerViewComponent() {
        this.ampm = 'ok';
        this.hours = 0;
        this.minutes = 0;
    }
    BsTimepickerViewComponent.decorators = [
        { type: Component, args: [{
                    selector: 'bs-timepicker',
                    template: "\n<div class=\"bs-timepicker-container\">\n  <div class=\"bs-timepicker-controls\">\n    <button class=\"bs-decrease\">-</button>\n    <input type=\"text\" [value]=\"hours\" placeholder=\"00\">\n    <button class=\"bs-increase\">+</button>\n  </div>\n  <div class=\"bs-timepicker-controls\">\n    <button class=\"bs-decrease\">-</button>\n    <input type=\"text\" [value]=\"minutes\" placeholder=\"00\">\n    <button class=\"bs-increase\">+</button>\n  </div>\n  <button class=\"switch-time-format\">{{ ampm }}\n    <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAABSElEQVQYV3XQPUvDUBQG4HNuagtVqc6KgouCv6GIuIntYBLB9hcIQpLStCAIV7DYmpTcRWcXqZio3Vwc/UCc/QEqfgyKGbr0I7nS1EiHeqYzPO/h5SD0jaxUZjmSLCB+OFb+UFINFwASAEAdpu9gaGXVyAHHFQBkHpKHc6a9dzECvADyY9sqlAMsK9W0jzxDXqeytr3mhQckxSji27TJJ5/rPmIpwJJq3HrtduriYOurv1a4i1p5HnhkG9OFymi0ReoO05cGwb+ayv4dysVygjeFmsP05f8wpZQ8fsdvfmuY9zjWSNqUtgYFVnOVReILYoBFzdQI5/GGFzNHhGbeZnopDGU29sZbscgldmC99w35VOATTycIMMcBXIfpSVGzZhA6C8hh00conln6VQ9TGgV32OEAKQC4DrBq7CJwd0ggR7Vq/rPrfgB+C3sGypY5DAAAAABJRU5ErkJggg==\" alt=\"\">\n  </button>\n</div>\n"
                },] },
    ];
    /** @nocollapse */
    BsTimepickerViewComponent.ctorParameters = function () { return []; };
    return BsTimepickerViewComponent;
}());
export { BsTimepickerViewComponent };
//# sourceMappingURL=bs-timepicker-view.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/themes/bs/bs-timepicker-view.component.js
// module id = 1017
// module chunks = 33